import React from 'react';
import { useNavigate } from 'react-router-dom';

function SessionsPage() {
  const navigate = useNavigate();
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--bg-secondary)', color:'#fff', gap:16 }}>
      <div style={{ fontSize:32 }}>📋</div>
      <h2 style={{ fontSize:20, fontWeight:700 }}>Sessioni Salvate</h2>
      <p style={{ color:'#aaa', fontSize:14 }}>Pagina in costruzione</p>
      <button style={{ background:'#2196F3', color:'#fff', border:'none', borderRadius:6, padding:'10px 20px', cursor:'pointer', fontSize:14 }} onClick={() => navigate('/')}>← Torna all'app</button>
    </div>
  );
}
export default SessionsPage;
